export const EDIT_SWAP_SIM_CARD_OPEN_MODAL = "EDIT_SWAP_SIM_CARD_OPEN_MODAL";
export const EDIT_SWAP_SIM_CARD_CLOSE_MODAL = "EDIT_SWAP_SIM_CARD_CLOSE_MODAL";

export const EDIT_SWAP_SIM_CARD_GET_DEVICE_REQUEST = "EDIT_SWAP_SIM_CARD_GET_DEVICE_REQUEST";
export const EDIT_SWAP_SIM_CARD_GET_DEVICE_RESULT = "EDIT_SWAP_SIM_CARD_GET_DEVICE_RESULT";

export const EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_REQUEST = "EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_REQUEST";
export const EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_RESULT = "EDIT_SWAP_SIM_CARD_GET_SIM_DETAILS_RESULT";

export const EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_REQUEST = "EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_REQUEST";
export const EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_RESULT = "EDIT_SWAP_SIM_CARD_UPDATE_UNIT_SIM_CARD_RESULT";

